<div class="wrapper">
  <div class="text-wrapper">
    <!-- Editable Input Field -->
    @if (showText || text === '') {
      <input class="text-input" type="text" [(ngModel)]="text" [focusInput]="showText"
        (blur)="saveText()" (keyup.enter)="onEnter($event)" [maxlength]="maxInputLength"
        [attr.placeholder]="'Enter value...'" [attr.aria-label]="'Edit text field'">
    }

    <!-- Displayed Text (Double-Click to Edit) -->
    @if (!showText && text !== '') {
      <div (dblclick)="showText = true" (keydown.enter)="showText = true"
        (keydown.space)="$event.preventDefault(); showText = true" tabindex="0"
        [attr.aria-label]="'Text: ' + text + ', double-click to edit'">
            <span [ngClass]="{
                'default': textClass === 'default',
                'modified': textClass === 'modified'
            }">
          {{ text }}
        </span>
      </div>
    }
  </div>
</div>